import { graphql } from '@mp/graphql/generated';
import { useGraphQLQuery } from '@mp/hooks/useGraphQLRequest';
import { type ResultOf } from '@graphql-typed-document-node/core';

const LocationGql = graphql(`
  query Location($id: Int!) {
    location(id: $id) {
      id
      name
      state {
        abbreviation
      }
    }
  }
`);

export const useLocation = (id: number) => {
  const enabled = !!id;

  const { data, isLoading, isInitialLoading } = useGraphQLQuery<ResultOf<typeof LocationGql>>({
    operationName: 'Location',
    queryKey: ['location', id],
    query: LocationGql,
    variables: { id },
    enabled,
  });

  // React Query v4 keeps `isLoading: true` for a disabled query (it never fetches),
  // which would hang consumers that wait on a not-yet-resolvable id. Fall back to
  // `isInitialLoading` when disabled so callers see a settled (false) loading state.
  return { location: data?.location, isLoading: enabled ? isLoading : isInitialLoading };
};

export default useLocation;
